import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useCreateStaticDataTypeLabel = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createStaticDataTypeLabel', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type-label'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdateStaticDataTypeLabel = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateStaticDataTypeLabel', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type-label'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useDeleteStaticDataTypeLabel = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('deleteStaticDataTypeLabel', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type-label'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};
